import { required, optional, obj } from 'AppReact/schema';

const resident = {
  id: optional('integer'),
  name: optional('string'),
  is_current: optional('boolean')
}

export default {
  type: required('string'),
  template: required('string'),
  isVisible: required('boolean'),
  resident: obj(resident),
  unitName: optional('string'),
  emailSent: optional('boolean')
}
